import React from 'react';
import { Box, Typography, Modal, Button } from '@mui/material';

// Helper to convert YouTube watch URL to embed URL
function getYouTubeEmbedUrl(url) {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}?autoplay=1` : url;
}

const VideoModal = ({ open, onClose, title, videoUrl, content, excerpt }) => (
  <Modal
    open={open}
    onClose={onClose}
    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
  >
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderRadius: 3, 
      boxShadow: 8, 
      p: { xs: 3, sm: 5 }, 
      minWidth: { xs: '90vw', sm: 500, md: 700 }, 
      maxWidth: '95vw',
      maxHeight: '90vh',
      overflow: 'auto',
      display: 'grid', 
      gridTemplateRows: 'auto auto 1fr auto', 
      rowGap: 2 
    }}>
      <Typography variant="h5" fontWeight={700} color="primary" sx={{ textAlign: 'center', mb: 1 }}>
        Watch: {title}
      </Typography>
      
      <Box sx={{ position: 'relative', width: '100%', pt: '56.25%' }}>
        <iframe
          src={getYouTubeEmbedUrl(videoUrl)}
          title={title}
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
            borderRadius: '8px'
          }}
        />
      </Box>
      
      {excerpt && (
        <Typography variant="body2" color="text.secondary" paragraph>
          {excerpt}
        </Typography>
      )}
      
      {content && (
        <Typography variant="body1" sx={{ 
          whiteSpace: 'pre-wrap',
          lineHeight: 1.6,
          fontSize: '1.1rem'
        }}>
          {content}
        </Typography>
      )}
      
      <Button 
        variant="contained" 
        color="primary" 
        sx={{ borderRadius: 999, fontWeight: 600 }} 
        onClick={onClose}
      >
        Close
      </Button>
    </Box>
  </Modal>
);

export default VideoModal; 